import { Button, ButtonGroup, ButtonGroupProps, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { ReactNode } from 'react';
import {
  KeyFilterChartCTDRelationshipView,
  KeyFilterChartTeuPort,
  KeyFilterChartTradeDataUnitBy,
  KeyFilterChartTradeDataViewBy,
  KeyFilterChartUnitBy,
  KeyFilterChartViewBy,
  KeyFilterChartViewDataForLast,
  TypeBuyerSupplier,
} from 'src/utils/constants/enum';

interface IProps {
  label: ReactNode;
  buttons: Array<IListButtonItem>;
  active: IListButtonItem['key'];
  size?: ButtonGroupProps['size'];
  onClick: (key: IListButtonItem['key']) => void;
}

export interface IListButtonItem {
  label: ReactNode;
  key:
    | KeyFilterChartTradeDataUnitBy
    | KeyFilterChartUnitBy
    | KeyFilterChartViewDataForLast
    | KeyFilterChartViewBy
    | KeyFilterChartTeuPort
    | KeyFilterChartCTDRelationshipView
    | KeyFilterChartTradeDataViewBy
    | KeyFilterChartTeuPort
    | TypeBuyerSupplier;
  disabled?: boolean;
}

const ButtonGroupFilter = ({ label, buttons, active, size = 'small', onClick }: IProps) => {
  return (
    <Stack direction={'row'} alignItems={'center'} spacing={1}>
      <Typography variant="subtitle2">{label}</Typography>
      <ButtonGroup size={size}>
        {buttons.map(({ label, key, disabled }: IListButtonItem) => {
          const isActive = key === active;
          if (isActive) {
            return (
              <Button onClick={() => onClick(key)} disabled={disabled} variant="contained" color="primary" key={key}>
                {label}
              </Button>
            );
          }
          return (
            <Button onClick={() => onClick(key)} disabled={disabled} color="inherit" key={key}>
              {label}
            </Button>
          );
        })}
      </ButtonGroup>
    </Stack>
  );
};

export default ButtonGroupFilter;
